import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import CbClientes from "../CbClientes"
import "./index.css"
import ClienteViaje from "../ClienteViaje"
import { useDispatch } from "react-redux"
import { obtenerListadoClientes } from "../../../ducks/clientesDuck"
import { useEffect } from "react"
import BotonReporte from "../ClienteViaje/BotonReporte"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import ButtonReturn from "../../../global/ButtonReturn"
import { useParams } from "react-router-dom"

const VClientes = () => {
    const dispatch = useDispatch()
    const { referencia } = useParams()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Cargando lista de clientes..." }))
        dispatch(obtenerListadoClientes()).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
    return (
        <HomePage>
            <Container>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid item xs={5}>
                        <CbClientes />
                    </Grid>
                    <Grid item xs={7}>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                            <BotonReporte />
                            {
                                (referencia) &&
                                <ButtonReturn />
                            }
                        </div>
                    </Grid>
                </Grid>
            </Container>
            <Container>
                <ClienteViaje />
            </Container>
        </HomePage>
    )
}
export default VClientes